module.exports = __webpack_public_path__ + "static/image 97-0b4be3c238d45b72dde06bf826183f2c.png";